module.exports = __webpack_public_path__ + "img/mathmix.9bf4fd45.png";